import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { AppConstants } from "../constants/constants";
import { translationsContentObject } from "../constants/DynamicTranslationContents";

@Pipe({
  name: "joinStrings"
})
export class JoinArrayOfStringsPipe implements PipeTransform {

  siteLanguageCode: string;
  constructor(@Inject(LOCALE_ID) protected localeId: string) {
    this.siteLanguageCode = this.localeId;
  }
  
  transform(objects: string[], junction: string = AppConstants.BLANK, 
    isActivity: boolean = false) {
      
    if (!objects || objects.length === 0) {
      return AppConstants.BLANK;
    }

    if(isActivity && this.siteLanguageCode === AppConstants.WELSH_LANG_CODE) {
      const translatedValues = objects.map(text => {
        const translationKey = Object.keys(translationsContentObject)
          .find(e => e.split(AppConstants.HASH)[0] === text)

        return translationKey ? translationsContentObject[translationKey] : text;
      });

      return translatedValues.join(`${junction} `);
    }

    // Concatenate the strings with the separator
    return objects.join(`${junction} `);
  }
}